<template>
  <v-footer height='100'>
<svg>
  <g id="_1" data-name="1"
    transform='translate(200, 0)'>
    <line id='leg1' x1="16.74" y1="39.75" x2="31.22" y2="36.51" style="fill:none;stroke:#231f20;stroke-miterlimit:10"/>
    <line id='leg2' x1="27.27" y1="51.24" x2="36.28" y2="38.24" style="fill:none;stroke:#231f20;stroke-miterlimit:10"/>
    <line id='leg3' x1="49.82" y1="49.54" x2="63.24" y2="38.24" style="fill:none;stroke:#231f20;stroke-miterlimit:10"/>
    <line id='leg4' x1="67.54" y1="49.54" x2="70.61" y2="33.76" style="fill:none;stroke:#231f20;stroke-miterlimit:10"/>
    <path id='body' d="M90.28,69.7c0,8-12.24,14.47-27.34,14.47A44.34,44.34,0,0,1,45.7,80.93C39.54,78.28,35.6,74.23,35.6,69.7c0-8,12.24-14.47,27.34-14.47S90.28,61.7,90.28,69.7Z" transform="translate(-14.48 -44.41)" style="fill:none;stroke:#231f20;stroke-miterlimit:10"/>
    <ellipse id='head' cx="30.54" cy="63" rx="9.04" ry="6.6" transform="translate(-50.05 41.64) rotate(-83.36)" style="fill:none;stroke:#231f20;stroke-miterlimit:10"/>
    <polyline id='ear1' points="12.15 11.72 8.96 6.03 14.78 9.34" style="fill:none;stroke:#231f20;stroke-miterlimit:10"/>
    <polyline id='ear2' points="9.97 23.98 5.18 29.21 12.69 27.3" style="fill:none;stroke:#231f20;stroke-miterlimit:10"/>
    <polyline id='tail' points="74.06 20.2 82.39 17.62 88.76 8.88 94.08 18.59" style="fill:none;stroke:#231f20;stroke-miterlimit:10"/>
  </g>
</svg>
  </v-footer>
</template>
<script>
  import anime from 'animejs'
  export default {
    name: 'tu-footer',
    mounted: function () {
      this.animate()
    },
    methods: {
      animate: function () {
        anime({
          targets: '#_1',
          translateX: [{value: 200, duration: 0}, {value: 195, duration: 2000, easing: 'easeInCubic'}, {value: 190, duration: 2000, easing: 'easeInCubic'}],
          loop: true
        })
        anime({
          targets: '#leg1',
          easing: 'easeInCubic',
          x1: [{value: '28.94'}, {value: '23.94'}],
          y1: [{value: '51.35'}, {value: '51.35'}],
          x2: [{value: '31.29'}, {value: '31.29'}],
          y2: [{value: '36.63'}, {value: '36.63'}],
          duration: 2000,
          loop: true
        })
        anime({
          targets: '#leg2',
          easing: 'easeInCubic',
          x1: [{value: '24.48'}, {value: '35.43'}],
          y1: [{value: '49.65'}, {value: '51.35'}],
          x2: [{value: '36.35'}, {value: '36.35'}],
          y2: [{value: '38.35'}, {value: '38.35'}],
          duration: 2000,
          loop: true
        })
        anime({
          targets: '#leg3',
          easing: 'easeInCubic',
          x1: [{value: '69.16'}, {value: '64.58'}],
          y1: [{value: '51.35'}, {value: '51.35'}],
          x2: [{value: '63.31'}, {value: '63.31'}],
          y2: [{value: '38.35'}, {value: '38.35'}],
          duration: 2000,
          loop: true
        })
        anime({
          targets: '#leg4',
          easing: 'easeInCubic',
          x1: [{value: '63.41'}, {value: '78.63'}],
          y1: [{value: '49.65'}, {value: '49.65'}],
          x2: [{value: '70.67'}, {value: '70.67'}],
          y2: [{value: '33.87'}, {value: '33.87'}],
          duration: 2000,
          loop: true
        })
        // anime({
        //   targets: '#head',
        //   easing: 'easeInCubic',
        //   cx: [{value: '31.24'}, {value: '15.97'}],
        //   cy: [{value: '59.74'}, {value: '15.61'}],
        //   rx: [{value: '9.04'}, {value: '9.04'}],
        //   ry: [{value: '6.6'}, {value: '6.6'}],
        //   rotate: [{value: -32.87}, {value: 0}],
        //   translateX: [{value: -41.9}, {value: 0}],
        //   translateY: [{value: -17.89}, {value: 0}],
        //   duration: 2000,
        //   loop: true
        // })
        anime({
          targets: '#ear1',
          easing: 'easeInCubic',
          points: [{value: '19.57 7.94 21.93 1.85 23.09 8.45'}, {value: '22.34 10.93 27.62 7.1 25.01 13.27'}],
          duration: 2000,
          loop: true
        })
        anime({
          targets: '#ear2',
          easing: 'easeInCubic',
          points: [{value: '8.72 14.06 1.65 13.69 7.9 18.27'}, {value: '9.9 10.18 4.16 6.03 6.92 13.27'}],
          duration: 2000,
          loop: true
        })
        anime({
          targets: '#tail',
          easing: 'easeInCubic',
          points: [{value: '74.12 20.31 82.45 17.73 78.73 33.87 82.97 31.16'}, {value: '74.12 20.31 82.45 17.73 87.56 30.5 91.82 30.5'}],
          duration: 2000,
          loop: true
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/animations/Footer.vue